import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function GiftIcon({ width, height, viewBox, style, className }: IIcon) {
    const newViewProps = '0 0 15 15' ?? viewBox;
    return (
        <Icon
            width={width}
            height={height}
            viewBox={newViewProps}
            style={style}
            className={className}
        >
            <g>
                <path d="M14.022 2.844c.54 0 .978.429.978.957v1.435a.484.484 0 0 1-.49.478H.49A.484.484 0 0 1 0 5.236V3.8c0-.528.438-.957.978-.957h1.089a1.674 1.674 0 0 1-.266-.737A1.876 1.876 0 0 1 2.945.167a1.952 1.952 0 0 1 2.09.329l1.38 1.223c.27-.288.656-.47 1.085-.47.428 0 .814.181 1.083.469L9.962.496a1.95 1.95 0 0 1 2.09-.33 1.876 1.876 0 0 1 1.144 1.94 1.675 1.675 0 0 1-.266.738h1.092zm-7.99-.16l.001-.013-1.654-1.467a.958.958 0 0 0-1.054-.156.944.944 0 0 0-.528.623.95.95 0 0 0 .935 1.173h2.3v-.16zm6.193-.704c.034-.464-.239-.851-.704-.987-.324-.094-.675.01-.925.231L8.967 2.668v.177h2.253c.51 0 .969-.368 1.005-.865zM.715 6.429h5.714V15H1.723c-.557 0-1.009-.46-1.009-1.029V6.43zm7.856 0h5.715v7.542c0 .569-.452 1.029-1.009 1.029H8.571V6.429z" />
            </g>
        </Icon>
    );
}
